var map = {
	"./_settings.scss": 795,
	"./base/_alert-boxes.scss": 796,
	"./base/_badges.scss": 797,
	"./base/_base.scss": 798,
	"./base/_cw-footer.scss": 799,
	"./base/_fonts.scss": 800,
	"./base/_forms.scss": 801,
	"./base/_grid.scss": 802,
	"./base/_layout.scss": 803,
	"./base/_modal.scss": 804,
	"./base/_nav-bar.scss": 805,
	"./base/_normal_font.scss": 291,
	"./base/_offcanvas.scss": 806,
	"./base/_pagination.scss": 807,
	"./base/_panels.scss": 808,
	"./base/_sharing.scss": 809,
	"./base/_switches.scss": 810,
	"./base/_tables.scss": 811,
	"./base/_tooltips.scss": 812,
	"./base/_type.scss": 813,
	"./base/_video.scss": 814,
	"./base/_visibility.scss": 815,
	"./base/buttons/_all.scss": 816,
	"./base/buttons/_mixins.scss": 817,
	"./base/buttons/_sharing.scss": 818,
	"./base/forms/_checkboxes.scss": 819,
	"./base/forms/_input-combos.scss": 820,
	"./base/forms/_non-text.scss": 821,
	"./base/forms/_text-fields.scss": 822,
	"./base/nav-bar/_base-with-links.scss": 823,
	"./base/nav-bar/_base.scss": 824,
	"./base/nav-bar/_fade.scss": 825,
	"./base/nav-bar/_inverted.scss": 826,
	"./base/nav-bar/_large-up.scss": 827,
	"./pages/accounts.scss": 828,
	"./pages/admin.scss": 829,
	"./pages/admin/offline_donations.scss": 830,
	"./pages/authorization.scss": 831,
	"./pages/birthdays.scss": 832,
	"./pages/campaigns.scss": 833,
	"./pages/charityball.scss": 834,
	"./pages/donations.scss": 835,
	"./pages/donations/_donate-form.scss": 836,
	"./pages/donations/_generic-right-side-donate.scss": 837,
	"./pages/donations/_hidden-campaign.scss": 838,
	"./pages/donations/_sponsor-recognition.scss": 839,
	"./pages/donations/_thank-you.scss": 840,
	"./pages/donations/components/_ach-popout-form.scss": 841,
	"./pages/donations/components/_apple-pay-button.scss": 842,
	"./pages/donations/components/_browser-fallback.scss": 843,
	"./pages/donations/components/_donate-buttons.scss": 844,
	"./pages/donations/components/_donate-by-check-modal.scss": 845,
	"./pages/donations/components/_donation-form-inputs.scss": 846,
	"./pages/donations/components/_gift_aid.scss": 847,
	"./pages/donations/components/_iho.scss": 848,
	"./pages/donations/components/_offscreen-donate-components.scss": 849,
	"./pages/donations/components/_stripe-elements.scss": 850,
	"./pages/donations/direct.scss": 851,
	"./pages/donations/general.scss": 852,
	"./pages/donations/gift-the-spring.scss": 853,
	"./pages/donations/home.scss": 854,
	"./pages/donations/in-honor-of.scss": 855,
	"./pages/donations/sponsor.scss": 856,
	"./pages/donations/the-spring-new.scss": 857,
	"./pages/donations/thespring.scss": 858,
	"./pages/donations/user.scss": 859,
	"./pages/edit_mailing_list_subscriber.scss": 860,
	"./pages/exceptions.scss": 861,
	"./pages/founders.scss": 862,
	"./pages/mailing-list-subscribers.scss": 863,
	"./pages/premium_impact_profile.scss": 864,
	"./pages/profile/bps_membership.scss": 865,
	"./pages/profile/my_projects.scss": 866,
	"./pages/profile/shared.scss": 867,
	"./pages/profile/spring_membership.scss": 868,
	"./pages/profile/user_private.scss": 869,
	"./pages/profile/user_public.scss": 870,
	"./pages/projects/_country_icons.scss": 871,
	"./pages/projects/projects.scss": 872,
	"./pages/redeem-the-spring.scss": 873,
	"./pages/search.scss": 874,
	"./pages/spring-mailing-list-subscribers.scss": 875,
	"./pages/static_pages/about.scss": 876,
	"./pages/static_pages/brand_partnerships.scss": 877,
	"./pages/static_pages/company_match.scss": 878,
	"./pages/static_pages/company_match_iframe.scss": 879,
	"./pages/static_pages/completed_projects.scss": 880,
	"./pages/static_pages/css_docs.scss": 881,
	"./pages/static_pages/education.scss": 882,
	"./pages/static_pages/error.scss": 883,
	"./pages/static_pages/financials.scss": 884,
	"./pages/static_pages/fundraise.scss": 885,
	"./pages/static_pages/gala_dashboard.scss": 886,
	"./pages/static_pages/gift_guide.scss": 887,
	"./pages/static_pages/hundred_percent_model.scss": 888,
	"./pages/static_pages/in_kind_donations.scss": 889,
	"./pages/static_pages/internships.scss": 890,
	"./pages/static_pages/jobs.scss": 891,
	"./pages/static_pages/kids.scss": 892,
	"./pages/static_pages/local_partners.scss": 893,
	"./pages/static_pages/mission.scss": 894,
	"./pages/static_pages/our_approach.scss": 895,
	"./pages/static_pages/our_work.scss": 896,
	"./pages/static_pages/privacy.scss": 897,
	"./pages/static_pages/scott_harrison_story.scss": 898,
	"./pages/static_pages/scotts_story.scss": 899,
	"./pages/static_pages/sensors.scss": 900,
	"./pages/static_pages/staff.scss": 901,
	"./pages/static_pages/the_pool.scss": 902,
	"./pages/static_pages/volunteer.scss": 903,
	"./pages/static_pages/whywater.scss": 904,
	"./pages/subscriptions.scss": 905,
	"./pages/the_spring_series.scss": 906,
	"./pages/thirst/thirst.scss": 907,
	"./pages/uk/about.scss": 908,
	"./pages/uk/home.scss": 909,
	"./pages/uk/partnerships.scss": 910,
	"./pages/uk/privacy.scss": 911,
	"./pages/uk/uk.scss": 912,
	"./pages/unpledge.scss": 913,
	"./pages/video_landing_page.scss": 914,
	"./pages/wwd/community.scss": 915,
	"./pages/wwd/discover.scss": 916,
	"./pages/wwd/explore.scss": 917,
	"./pages/wwd/profile.scss": 918,
	"./pages/wwd/shared.scss": 919,
	"./pages/wwd/welcome.scss": 920,
	"./patterns/action-tiles.scss": 921,
	"./patterns/avatar-initial.scss": 922,
	"./patterns/cards.scss": 923,
	"./patterns/cw-icon-spin.scss": 924,
	"./patterns/full-bottom-bg.scss": 925,
	"./patterns/image-fill.scss": 926,
	"./patterns/module.scss": 927,
	"./patterns/progress.scss": 928,
	"./patterns/side-by-side.scss": 929,
	"./patterns/tabs.scss": 930,
	"./patterns/text-separator.scss": 931,
	"./patterns/yellow-underlined.scss": 932,
	"./react-components/email-capture-modal.scss": 933,
	"./react-components/journey-player.scss": 934,
	"./react-components/mailing-list-intercept-modal.scss": 935,
	"./react-components/people-served-input.scss": 936,
	"./settings/_colors.scss": 937,
	"./settings/_general.scss": 938,
	"./settings/_media-queries.scss": 939,
	"./settings/_mixins.scss": 940,
	"./settings/_type.scss": 941,
	"./shared/acts-as-user.scss": 942,
	"./shared/breadcrumbs.scss": 943,
	"./shared/clipboard-button.scss": 944,
	"./shared/cookie_banner.scss": 945,
	"./shared/datepicker.scss": 946,
	"./shared/geosuggest.scss": 947,
	"./shared/grecaptcha.scss": 948,
	"./shared/hide-donate-links.scss": 949,
	"./shared/intl-tel-input.scss": 950,
	"./shared/mailing-list-form.scss": 951,
	"./shared/mailing-list-sign-up-button.scss": 952,
	"./shared/parsley.scss": 953,
	"./shared/percy.scss": 954,
	"./shared/public_campaign_card_details.scss": 955,
	"./shared/simple-form.scss": 956,
	"./shared/sly-quiz.scss": 957,
	"./shared/spring_logo_svg.scss": 958,
	"./shared/spring_mark_svg.scss": 959,
	"./shared/video-box-container.scss": 960,
	"./tailwinds.scss": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;